import {useEffect} from 'react';
import {useSearchParams} from "react-router-dom";
import {useDispatch} from "react-redux";
import {actionCreators} from '@App/state'
import {bindActionCreators} from "@reduxjs/toolkit";

/**
 * Checks if any customer-related data is found in the query parameters and saves them to the store.
 */
export const useCustomerParameters = () => {

    const dispatch = useDispatch();
    const {
        setFirstName,
        setLastName,
        setEmail,
        setPhone,
        setSalutation,
        setNumberPlate
    } = bindActionCreators(actionCreators, dispatch)

    const [searchParams] = useSearchParams()

    const sanitize = (stringValue: string | undefined | null) => {
        if(typeof stringValue === "string" && stringValue.trim().length > 0){
            return decodeURIComponent(stringValue.trim());
        }
        return null
    }

    useEffect(() => {
        // get url params
        const firstname = sanitize(searchParams.get('firstname') || searchParams.get('firstName'));
        const lastname = sanitize(searchParams.get('lastname') || searchParams.get('lastName'));
        const salutation = Number(searchParams.get('salutation'));
        const mail = sanitize(searchParams.get('mail'));
        const phoneCountry = sanitize(searchParams.get('phoneCountry'));
        const phoneNumber = sanitize(searchParams.get('phoneNumber'));
        const numberPlateRegion = sanitize(searchParams.get('numberPlateRegion') || searchParams.get('numberPlateRegion'));
        const numberPlateFirstID = sanitize(searchParams.get('numberPlateFirstID') || searchParams.get('numberPlateFirstId')  || searchParams.get('numberPlateFirstId'));
        const numberPlateSecondId = sanitize(searchParams.get('numberPlateSecondId') || searchParams.get('numberPlateSecondId'));

        firstname && setFirstName(firstname);
        lastname && setLastName(lastname);
        (salutation === 1 || salutation === 2) && setSalutation(salutation);
        mail && setEmail(mail);
        phoneCountry && phoneNumber && setPhone({country: phoneCountry, number: phoneNumber});
        numberPlateRegion && numberPlateFirstID && numberPlateSecondId && setNumberPlate({region: numberPlateRegion, firstID: numberPlateFirstID, secondID: numberPlateSecondId});
    }, [searchParams]);

    const customerQueryParams = () => {
        return {
            // returning nothing for now, because we just want the customer values to be set once
            // and never overwritten.
        }
    }

    return {customerQueryParams}
}
